module.exports = {
	"Announcement": {
		"Know More": "Per saperne di più"
	},
	"Appointment": {
		"Conditions": "Facendo clic su “Confermare“, dichiara di aver letto l'Informativa sulla Privacy e autorizza %(brand)s a procedere al trattamento dei dati personali necessari per dare seguito alla Sua richiesta, alle condizioni stabilite dall'Informativa sulla Privacy.",
		"Confirmation": "Abbiamo ricevuto la tua richiesta di appuntamento in boutique con uno dei nostri consulenti per un’assistenza personalizzata. Riceverai nelle prossime ore un'e-mail di conferma.",
		"Description": "Per dei consigli personalizzati, Dior ti invita a prendere appuntamento in boutique con un consulente.",
		"Get an appointment": "Fissare un appuntamento",
		"Motives": "Motivi",
		"Universes": "Universi"
	},
	"DiorMap": {
		"Search in this area": "Cerca in quest’area"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s Risultato",
			"other": "%(count)s Risultati",
			"zero": "%(count)s Risultato"
		},
		"Refine": "Affinare",
		"RefineAria": "Affina la ricerca spuntando le caselle sottostanti",
		"Are you looking for?": "Cerchi una boutique specializzata negli universi Moda Donna, Uomo, Baby, Gioielleria o Orologeria?"
	},
	"Footer": {
		"Download the applications": "Scaricare le applicazioni",
		"Language": "Lingua",
		"Newsletter": "Es.: Christian@dior.fr",
		"Ok": "OK",
		"Subscribe to newsletter": "Iscriversi alla Newsletter"
	},
	"Form": {
		"All fields are mandatory": "Tutti i campi sono obbligatori",
		"Civility": "Titolo",
		"Comments": "Commenti",
		"Conditions": "Per ricevere un'e-mail di conferma da parte di %(brand)s spuntare la casella qui sotto. L’utente dispone dei diritti di accesso, rettifica, soppressione e opposizione al trattamento dei propri dati, diritti esercitabili scrivendo a \"contact@dior.com\"",
		"Date": "Preferenze di data ",
		"Email": "E-mail",
		"Hour": "Preferenze di orario",
		"Invalid E-mail address": "Indirizzo email non valido",
		"Mr": "Signor",
		"Mrs": "Signora",
		"Name": "Cognome",
		"Phone": "Telefono",
		"Required fields": "Campi richiesti",
		"Submit": "Confermare",
		"Surname": "Nome"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "Boutique Dior nella tua città: alta moda, profumi e pelletteria",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "Arrivo",
		"Departure": "Partenza",
		"Details": "Dettagli",
		"Error": "Siamo spiacenti ma non è stato possibile calcolare l’itinerario richiesto, ti invitiamo a riprovare modificando l’indirizzo di partenza e/o il mezzo di trasporto utilizzato",
		"Follow the itinerary": "Seguire l’itinerario",
		"Itinerary": "Itinerario",
		"modeBICYCLING": "In bicicletta",
		"modeDRIVING": "In macchina",
		"modeTRANSIT": "Trasporti pubblici",
		"modeWALKING": "A piedi",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "Si prega di utilizzare il telefono in modalità verticale"
	},
	"NavMobile": {
		"Home": "Home"
	},
	"Newsletter": {
		"Dior Newsletter": "Newsletter Dior",
		"Fashion and accessories": "Moda & Accessori",
		"I wish to receive the %(newsletter)s newsletter": "Desidero ricevere informazioni sulle ultime novità %(newsletter)s",
		"Newsletter Confirmation": "L’iscrizione alla newsletter è stata effettuata con successo",
		"Perfume and beauty": "Profumi & Bellezza",
		"Receive our newsletter": "Ricevi la nostra newsletter",
		"Your universes": "I tuoi universi "
	},
	"ResultsBlock": {
		"Dior boutiques": "Boutique Dior",
		"Too far": "Troppi risultati, affina la ricerca selezionando un’area più piccola.",
		"No result": "Non è stata trovata nessuna boutique",
		"Other shops": "Altre boutique",
		"Results": "Risultati della ricerca",
		"Fewer results, zoom in": "Meno risultati, zoom in",
		"More results, zoom out": "Più risultati, zoom out",
		"Fewer results": "Meno risultati",
		"More results": "Più risultati"
	},
	"SearchBlock": {
		"Geolocation": "Attiva la geolocalizzazione per trovare le boutique vicino a te",
		"Search": "Cercare"
	},
	"Share": {
		"Conditions": "Facendo clic su “Conferma“ dichiari di aver letto l'Informativa sulla Privacy e autorizzi %(brand)s a procedere al trattamento dei dati personali necessari per dare seguito alla tua richiesta, alle condizioni stabilite dall'Informativa sulla Privacy. Barrando l'apposita casella, autorizzi altresì il trattamento dei tuoi dati personali da parte di Christian Dior Couture per attività di direct marketing, che possono essere adattate sulla base delle informazioni personali in nostro possesso e delle tue preferenze.",
		"Recipient": "Il tuo destinatario",
		"Share Confirmation": "La scheda della tua boutique è stata inviata correttamente",
		"Share this shop": "Condividere la scheda della boutique",
		"Your favorite shop": "La tua boutique preferita"
	},
	"ShopBlock": {
		"Closed": "Chiuso",
		"Closed today": "Oggi chiuso",
		"Directions": "Itinerario",
		"DirectionsAria": "Indicazioni per %(shopName)s",
		"Make an appointment": "Fissare un appuntamento",
		"Open": "Aperto",
		"Opening time": "Orari di apertura",
		"OpeningAria": "Maggiori informazioni sugli orari di apertura",
		"ResultNumber": "Risultato numero %(number)s",
		"Services": "Servizi",
		"ServicesAria": "Maggiori informazioni sui servizi",
		"Share": "Condividere",
		"Special hours": "Special hours",
		"Today until %(hour)s": "Oggi fino a %(hour)s",
		"Universes": "Universi",
		"UniversesAria": "Maggiori informazioni sugli Universi",
		"and": "and",
		"from": "from",
		"publicHolidays": "La boutique potrebbe essere chiusa",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/it_it/translations.json
// module id = 867
// module chunks = 0